function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
//
// ## Description
// `TextNote` is a notation element that is positioned in time. Generally
// meant for objects that sit above/below the staff and inline with each other.
// Examples of this would be such as dynamics, lyrics, chord changes, etc.
import { Vex } from './vex';
import { Note } from './note';
import { Glyph } from './glyph';
export var TextNote = /*#__PURE__*/function (_Note) {
  _inherits(TextNote, _Note);

  var _super = _createSuper(TextNote);

  _createClass(TextNote, null, [{
    key: "Justification",
    get: function get() {
      return {
        LEFT: 1,
        CENTER: 2,
        RIGHT: 3
      };
    } // Glyph data

  }, {
    key: "GLYPHS",
    get: function get() {
      return {
        'segno': {
          code: 'segno'
        },
        'tr': {
          code: 'ornamentTrill'
        },
        'mordent': {
          code: 'ornamentMordent'
        },
        'mordent_upper': {
          code: 'ornamentShortTrill'
        },
        'mordent_lower': {
          code: 'ornamentMordent'
        },
        'f': {
          code: 'dynamicForte'
        },
        'p': {
          code: 'dynamicPiano'
        },
        'm': {
          code: 'dynamicMezzo'
        },
        's': {
          code: 'dynamicSforzando'
        },
        'z': {
          code: 'dynamicZ'
        },
        'coda': {
          code: 'coda'
        },
        'pedal_open': {
          code: 'keyboardPedalPed'
        },
        'pedal_close': {
          code: 'keyboardPedalUp'
        },
        'caesura_straight': {
          code: 'caesura'
        },
        'caesura_curved': {
          code: 'caesuraCurved'
        },
        'breath': {
          code: 'breathMarkComma'
        },
        'tick': {
          code: 'breathMarkTick'
        },
        'turn': {
          code: 'ornamentTurn'
        },
        'turn_inverted': {
          code: 'ornamentTurnSlash'
        }
      };
    }
  }]);

  function TextNote(options) {
    var _this;

    _classCallCheck(this, TextNote);

    _this = _super.call(this, options);

    _this.setAttribute('type', 'TextNote'); // Note properties


    _this.text = options.text;
    _this.superscript = options.superscript;
    _this.subscript = options.subscript;
    _this.glyph = null;
    _this.font = _objectSpread({
      family: 'Arial',
      size: 12,
      weight: ''
    }, options.font); // Determine and set initial note width. Note that the text width is
    // an approximation and isn't very accurate. The only way to accurately
    // measure the length of text is with `canvasmeasureText()`

    if (options.glyph) {
      var struct = TextNote.GLYPHS[options.glyph];
      if (!struct) throw new Vex.RERR('Invalid glyph type: ' + options.glyph);
      _this.glyph = new Glyph(struct.code, 40, {
        category: 'textNote'
      });

      _this.setWidth(_this.glyph.getMetrics().width);
    }

    _this.line = options.line || 0;
    _this.smooth = options.smooth || false;
    _this.ignore_ticks = options.ignore_ticks || false;
    _this.justification = TextNote.Justification.LEFT;
    return _this;
  } // Set the horizontal justification of the TextNote


  _createClass(TextNote, [{
    key: "setJustification",
    value: function setJustification(just) {
      this.justification = just;
      return this;
    } // Set the Stave line on which the note should be placed

  }, {
    key: "setLine",
    value: function setLine(line) {
      this.line = line;
      return this;
    } // Pre-render formatting

  }, {
    key: "preFormat",
    value: function preFormat() {
      this.checkContext();
      if (this.preFormatted) return;

      if (this.smooth) {
        this.setWidth(0);
      } else {
        if (this.glyph) {// Width already set.
        } else {
          this.context.setFont(this.font.family, this.font.size, this.font.weight);
          this.setWidth(this.context.measureText(this.text).width);
        }
      }

      if (this.justification === TextNote.Justification.CENTER) {
        this.leftDisplacedHeadPx = this.width / 2;
      } else if (this.justification === TextNote.Justification.RIGHT) {
        this.leftDisplacedHeadPx = this.width;
      } // We reposition to the center of the note head


      this.rightDisplacedHeadPx = this.tickContext.getMetrics().glyphPx / 2;
      this.setPreFormatted(true);
    } // Renders the TextNote

  }, {
    key: "draw",
    value: function draw() {
      this.checkContext();

      if (!this.stave) {
        throw new Vex.RERR('NoStave', "Can't draw without a stave.");
      }

      this.setRendered();
      var ctx = this.context; // Reposition to center of note head

      var x = this.getAbsoluteX() + this.tickContext.getMetrics().glyphPx / 2; // Align based on tick-context width.

      var width = this.getWidth();

      if (this.justification === TextNote.Justification.CENTER) {
        x -= width / 2;
      } else if (this.justification === TextNote.Justification.RIGHT) {
        x -= width;
      }

      var y;

      if (this.glyph) {
        y = this.stave.getYForLine(this.line + -3);
        this.glyph.render(this.context, x, y);
      } else {
        y = this.stave.getYForLine(this.line + -3);
        this.applyStyle(ctx);
        ctx.setFont(this.font.family, this.font.size, this.font.weight);
        ctx.fillText(this.text, x, y);
        var height = ctx.measureText(this.text).height; // Write superscript

        if (this.superscript) {
          ctx.setFont(this.font.family, this.font.size / 1.3, this.font.weight);
          ctx.fillText(this.superscript, x + width + 2, y - height / 2.2);
        } // Write subscript


        if (this.subscript) {
          ctx.setFont(this.font.family, this.font.size / 1.3, this.font.weight);
          ctx.fillText(this.subscript, x + width + 2, y + height / 2.2 - 1);
        }

        this.restoreStyle(ctx);
      }
    }
  }]);

  return TextNote;
}(Note);